import { render, staticRenderFns } from "./UploadDocumentos.vue?vue&type=template&id=2f4b9674&lang=pug"
import script from "./UploadDocumentos.vue?vue&type=script&lang=js"
export * from "./UploadDocumentos.vue?vue&type=script&lang=js"
import style0 from "./UploadDocumentos.vue?vue&type=style&index=0&id=2f4b9674&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports